export default __webpack_public_path__ + "static/media/no-drag-gray.b72f15bf.svg";